class UtilityNav extends HTMLElement {
  constructor() {
    super();
    this.dropdowns = this.querySelectorAll('[data-hover-dropdown]');
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.bindEvents();

    this._megaCloseHandlers = [];
    this.querySelectorAll('[data-hover-dropdown]').forEach((dropdown) => {
      const handler = () => {
        document.dispatchEvent(new CustomEvent('mega-menu:close'));
      };
      dropdown.addEventListener('mouseenter', handler);
      this._megaCloseHandlers.push({ el: dropdown, handler });
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    this._megaCloseHandlers?.forEach(({ el, handler }) => {
      el.removeEventListener('mouseenter', handler);
    });
  }

  onDocumentClick(e) {
    if (!e.target.closest('[data-hover-dropdown]')) {
      this.dropdowns.forEach((d) => d.classList.remove('is-open'));
    }
  }

  bindEvents() {
    this.dropdowns.forEach((dropdown) => {
      let enterTimeout, leaveTimeout;

      dropdown.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimeout);
        enterTimeout = setTimeout(() => dropdown.classList.add('is-open'), 120);
      });

      dropdown.addEventListener('mouseleave', () => {
        clearTimeout(enterTimeout);
        leaveTimeout = setTimeout(() => dropdown.classList.remove('is-open'), 150);
      });

      const trigger = dropdown.querySelector('.utility-nav__trigger');
      trigger?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          dropdown.classList.toggle('is-open');
        }
      });

      dropdown.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          dropdown.classList.remove('is-open');
          dropdown.querySelector('.utility-nav__trigger')?.focus();
        }
      });
    });

    document.addEventListener('click', this.onDocumentClick);
  }
}

customElements.define('utility-nav', UtilityNav);
